import { Box, Notification } from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';

export function InfoBox(props: { title?: string; description?: string }) {
  const { isMobile } = useScreenSize();

  if (!props.title) return null;

  const content = (
    <>
      <strong>{props.title}</strong> {props.description}
    </>
  );

  if (isMobile) {
    return <Notification content={content} />;
  }

  return (
    <Box marginTop="-20">
      <Notification fullWidth={false} icon="info" content={content} />
    </Box>
  );
}
